export function ClaimDocumentsView() {
  return 'Documents';
}
